<template>
	<div v-cloak class="solution">
		<div class="banner">
			<div class="">
				<h5>产品中心</h5>
				<p>助力精神心理类疾病的个性化辅助诊疗服务</p>
			</div>
			<img src="@/assets/img_chanpin_zhongxin_banner.png" alt="" />
			<img src="@/assets/img_chanpin_zhongxin_banner_small.png" alt="" class="small" />
		</div>

		<div class="container cloudPlatform" id="yun">
			<div class="content">
				<div class="textarea">
					<!-- <span>云服务平台</span> -->
					<h5>
						<em class="icon">soulgym</em>
						精神心理疾病数字诊疗云服务平台
					</h5>
					<p>
						<em class="icon">soulgym</em>
						平台整合了脑结构科研团队全系列精神疾病精准诊疗技术，以MRI采集的脑神经影像、智能穿戴设备采集的行为数据、手机客户端采集的语音数据等全维度复杂医疗数据为基础，可实现个体心境情绪客观评估、语音特征辅助诊断、精确靶点rTMS治疗等，以AI精准诊断和非药物治疗为特点的全疾病周期的数字医疗技术，产品包括筛查-诊断-干预-康复四大功能模块。
					</p>
				</div>
				<img src="@/assets/img_chanpin_zhongxin_yunfuwu_pingtai.png" alt="" class="bg" />
			</div>
		</div>

		<div class="container" id="chun">
			<div class="content">
				<div class="title"><p>服务于心理健康管理的可穿戴设备</p></div>
				<div class="product">
					<img src="@/assets/img_shebei_shouhuan.png" alt="" />
					<div class="">
						<h5>复杂行为数据精准监测与采集</h5>
						<p>
							<em class="icon">soulgym</em>
							新一代手环实时监测毫秒级至分钟级变化的生理参数及生理活动，更高的数据精准度与强大的传感器。
						</p>
						<p>采集实时生理数据和行为参数并可实现生理可视化数据流，帮助医疗科研人员和医生对数据进行进一步的深入分析。</p>
					</div>
				</div>
			</div>
		</div>
		<div class="container productBox" id="vr">
			<div class="content">
				<div class="title"><p>沉浸式人工智能身心恢复虚拟现实交互训练系统</p></div>
				<div class="product">
					<img src="@/assets/img_chuandai_shebei_02.jpg" alt="" v-show="isApp" />
					<div class="">
						<h5>沉浸式人工智能身心恢复虚拟现实交互训练系统</h5>
						<p>
							将阿尔法脑波音乐集成心理减压技术，融入到使人心理状态产生积极变化的恢复性环境中，利用虚拟现实真实场景还原特性，打造出的沉浸式虚拟自然环境
							<em class="icon">soulgym</em>
							IVNE（Immersive Virtual Natural Environments）恢复体系。
						</p>
						<p>
							以用户体验为中心，根据使用者的不同兴趣特点及需求，结合三甲专科医院临床生物反馈大数据AI分析使用者各项生理数据，进行个性化心理健康调节、稳定个体情绪、协调生理状态，以实现焦虑、抑郁情绪及失眠障碍的精准干预。
						</p>
					</div>
					<img src="@/assets/img_chuandai_shebei_02.jpg" alt="" v-show="!isApp" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { GlobalMixin } from '@/util/globalMixin';
export default {
	name: 'Footer',
	mixins: [GlobalMixin],
	created() {
		// this.$nextTick(() => this.getLocal());
	},
	methods: {
		getLocal() {
			let select = localStorage.getItem('name');
			let elm = document.getElementById(select);
			if (select) {
				elm.scrollIntoView(true);
			}
		},
		//页面销毁时将auchorId设为空，防止其他页面进入是有锚点问题
		destroyed() {
			localStorage.setItem('name', '');
		}
	}
};
</script>

<style scoped lang="less">
.icon {
	font-style: inherit;
	position: relative;
	padding-right: 20px;
}
.icon::after {
	content: '®';
	position: absolute;
	font-size: 12px;
	top: 0;
	line-height: 1;
	right: 0;
}
.cloudPlatform {
	padding: 0 !important;
}

.container {
	width: 100%;
	padding: 87px 0 30px;
}

.productBox {
	background: #f2f6f9;

	.product h5 {
		margin-bottom: 40px;
		margin-top: 0;
	}
}

.product {
	width: 100%;
	display: flex;
	justify-content: space-between;
	margin-top: 98px;

	img {
		width: 438px;
		height: auto;
	}

	div {
		width: 545px;

		h5 {
			font-size: 30px;
			font-weight: 400;
			color: #01668b;
			line-height: 48px;
			font-weight: bold;
			margin-top: 50px;
			margin-bottom: 60px;
		}

		p {
			font-size: 16px;
			color: #8e8e8e;
			line-height: 30px;
			position: relative;
			padding-left: 15px;
			margin-bottom: 18px;
			word-break: break-all;
			text-align: justify;
		}

		p::after {
			content: '';
			position: absolute;
			left: 0;
			top: 13px;
			width: 5px;
			height: 5px;
			background: #16b7f3;
		}
	}
}

@media (max-width: 768px) {
	.title {
		width: 88%;
		margin: 0 auto;
	}

	.product {
		display: block;

		img {
			display: block;
			margin: 0 auto;
		}

		div {
			width: 100%;
			padding: 0 30px;
			box-sizing: border-box;

			h5 {
				font-size: 34px;
				color: #01668b;
				margin-bottom: 44px;
			}

			p {
				font-size: 28px;
				color: #8e8e8e;
				line-height: 48px;
			}

			p::after {
				top: 25px;
			}
		}
	}

	.productBox {
		.product h5 {
			margin-top: 43px;
		}
	}
}
</style>
